import React, { useState, useRef, useEffect } from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap-icons/font/bootstrap-icons.css';
import Modal from 'react-bootstrap/Modal';
import Form from 'react-bootstrap/Form';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Table from 'react-bootstrap/Table';
import Card from 'react-bootstrap/Card';
import Button from 'react-bootstrap/Button';
import axios from 'axios';
import { useNavigate, Link } from 'react-router-dom';

const Carstock = () => {
  const navigate = useNavigate();

  const [modalShow, setModalShow] = useState(false);
  const [ModalTable, setModalTable] = useState(false);
  const [inputFocused, setInputFocused] = useState(false);
  const [suche, setSuche] = useState(false);
  const [loading, setLoading] = useState(false);

  const [daten, setDaten] = useState([]);
  const [TableDaten, setTableDaten] = useState([]);

  const [searchfield, setSearchfield] = useState('');
  const [vertrag, setvertrag] = useState('');

  const inputRef = useRef(null);

  useEffect(() => {
    if (localStorage.getItem('loginData') == null) {
      navigate('/dhworld/login');
    }
  }, [navigate]);

  const focusInput = () => {
    if (inputRef.current) inputRef.current.focus();
  };

  const search = async () => {
    if (searchfield.trim() === '') return;

    setLoading(true);
    setModalShow(false);
    setSuche(true);

    try {
      const res = await axios.get('https://dhworld.dietenmeier-harsch.de/searchHistorie.php', {
        withCredentials: true,
        params: { searchfield },
      });
      setDaten(res.data.daten || []);
    } catch (err) {
      // optional: Fehlerhandling
    } finally {
      setLoading(false);
    }
  };

  const click = async (vertragsnummer) => {
    setvertrag(vertragsnummer);

    try {
      const res = await axios.get('https://dhworld.dietenmeier-harsch.de/searchVertragDetails.php', {
        withCredentials: true,
        params: { vertragsnummer },
      });
      setTableDaten(res.data.daten || []);
      setModalTable(true);
    } catch (err) {
      // optional: Fehlerhandling
    }
  };

  const handleClear = () => {
    setSearchfield('');
    setDaten([]);
    setSuche(false);
  };

  // Demo-Kacheln (später kannst du hier echte Daten reinsetzen)


  return (
    <div
      style={{
        backgroundColor: '#eceff2',
        minHeight: '100vh',
      }}
      className="container-fluid"
    >
      <div className="row pt-4">
        <div className="col-12">
          <Link to="/insight">
            <i style={{ fontSize: '25px' }} className="bi bi-arrow-return-left"></i>
          </Link>

          {/* Abstand statt <br> */}
          <div className="my-3" />

          {/* Lupe mit Suchtext und X (nur wenn gesucht und Suchfeld nicht leer) */}
          {suche && searchfield.trim() !== '' && (
            <Row
              className="align-items-center py-3 px-2 mb-3"
              style={{
                background: '#fff',
                border: '1px solid #e6e8ed',
                boxShadow: '0 2px 4px #00000012',
                minHeight: '5.2rem',
                borderRadius: '10px',
              }}
            >
              <Col xs="auto">
                <i
                  className="bi bi-search"
                  style={{ cursor: 'pointer', color: '#1245fb', fontSize: '20px' }}
                  onClick={() => setModalShow(true)}
                  title="Suche öffnen"
                ></i>
              </Col>

              <Col>
                <div className="fw-semibold">Suche:</div>
                <div>{searchfield}</div>
              </Col>

              <Col xs="auto">
                <i
                  className="bi bi-x-lg"
                  style={{ cursor: 'pointer', color: '#1245fb', fontSize: '20px' }}
                  onClick={handleClear}
                  title="Zurücksetzen"
                ></i>
              </Col>
            </Row>
          )}
        </div>
      </div>

      {/* ✅ HIER DIE ABSÄTZE / ABSTÄNDE ZWISCHEN DEN KACHELN:
          - Row className="g-4" = Abstand horizontal UND vertikal
          - mt-3 / mb-4 = zusätzlicher Außenabstand
      */}
      <Row className="g-4 mt-3 pb-4">
   
          <Col  md={3} sm={6} xs={12}>
            <Card className="h-100 shadow-sm">
              <Card.Body className="d-flex flex-column">
                <Card.Text className="fw-bold">KN-DH 17</Card.Text>

                <Button
                  variant="primary"
                  className="mt-auto"
                  onClick={() => {
                    // Beispiel: du könntest hier später navigieren oder Modal öffnen
                     navigate(`/fahrzeug/17`);
                  }}
                >
                  Zum Fahrzeug
                </Button>
              </Card.Body>
            </Card>
          </Col>

          <Col  md={3} sm={6} xs={12}>
            <Card className="h-100 shadow-sm">
              <Card.Body className="d-flex flex-column">
                <Card.Text className="fw-bold">KN-DH 65</Card.Text>

                <Button
                  variant="primary"
                  className="mt-auto"
                  onClick={() => {
                    // Beispiel: du könntest hier später navigieren oder Modal öffnen
                     navigate(`/fahrzeug/65`);
                  }}
                >
                  Zum Fahrzeug
                </Button>
              </Card.Body>
            </Card>
          </Col>

          <Col  md={3} sm={6} xs={12}>
            <Card className="h-100 shadow-sm">
              <Card.Body className="d-flex flex-column">
                <Card.Text className="fw-bold">KN-DH 57</Card.Text>

                <Button
                  variant="primary"
                  className="mt-auto"
                  onClick={() => {
                    // Beispiel: du könntest hier später navigieren oder Modal öffnen
                    navigate(`/fahrzeug/57`);
                  }}
                >
                  Zum Fahrzeug
                </Button>
              </Card.Body>
            </Card>
          </Col>

          <Col  md={3} sm={6} xs={12}>
            <Card className="h-100 shadow-sm">
              <Card.Body className="d-flex flex-column">
                <Card.Text className="fw-bold">KN-DH 98</Card.Text>

                <Button
                  variant="primary"
                  className="mt-auto"
                  onClick={() => {
                    // Beispiel: du könntest hier später navigieren oder Modal öffnen
                     navigate(`/fahrzeug/98`);
                  }}
                >
                  Zum Fahrzeug
                </Button>
              </Card.Body>
            </Card>
          </Col>

          <Col  md={3} sm={6} xs={12}>
            <Card className="h-100 shadow-sm">
              <Card.Body className="d-flex flex-column">
                <Card.Text className="fw-bold">KN-DH 444</Card.Text>

                <Button
                  variant="primary"
                  className="mt-auto"
                  onClick={() => {
                    // Beispiel: du könntest hier später navigieren oder Modal öffnen
                     navigate(`/fahrzeug/444`);
                  }}
                >
                  Zum Fahrzeug
                </Button>
              </Card.Body>
            </Card>
          </Col>

          <Col  md={3} sm={6} xs={12}>
            <Card className="h-100 shadow-sm">
              <Card.Body className="d-flex flex-column">
                <Card.Text className="fw-bold">KN-DH 490</Card.Text>

                <Button
                  variant="primary"
                  className="mt-auto"
                  onClick={() => {
                    // Beispiel: du könntest hier später navigieren oder Modal öffnen
                   navigate(`/fahrzeug/490`);
                  }}
                >
                  Zum Fahrzeug
                </Button>
              </Card.Body>
            </Card>
          </Col>

          <Col  md={3} sm={6} xs={12}>
            <Card className="h-100 shadow-sm">
              <Card.Body className="d-flex flex-column">
                <Card.Text className="fw-bold">KN-DH 850</Card.Text>

                <Button
                  variant="primary"
                  className="mt-auto"
                  onClick={() => {
                    // Beispiel: du könntest hier später navigieren oder Modal öffnen
                     navigate(`/fahrzeug/850`);
                  }}
                >
                  Zum Fahrzeug
                </Button>
              </Card.Body>
            </Card>
          </Col>

          <Col  md={3} sm={6} xs={12}>
            <Card className="h-100 shadow-sm">
              <Card.Body className="d-flex flex-column">
                <Card.Text className="fw-bold">KN-DH 34</Card.Text>

                <Button
                  variant="primary"
                  className="mt-auto"
                  onClick={() => {
                    // Beispiel: du könntest hier später navigieren oder Modal öffnen
                     navigate(`/fahrzeug/34`);
                  }}
                >
                  Zum Fahrzeug
                </Button>
              </Card.Body>
            </Card>
          </Col>

          <Col  md={3} sm={6} xs={12}>
            <Card className="h-100 shadow-sm">
              <Card.Body className="d-flex flex-column">
                <Card.Text className="fw-bold">KN-DH 47</Card.Text>

                <Button
                  variant="primary"
                  className="mt-auto"
                  onClick={() => {
                    // Beispiel: du könntest hier später navigieren oder Modal öffnen
                     navigate(`/fahrzeug/47`);
                  }}
                >
                  Zum Fahrzeug
                </Button>
              </Card.Body>
            </Card>
          </Col>

          <Col  md={3} sm={6} xs={12}>
            <Card className="h-100 shadow-sm">
              <Card.Body className="d-flex flex-column">
                <Card.Text className="fw-bold">KN-DH 58</Card.Text>

                <Button
                  variant="primary"
                  className="mt-auto"
                  onClick={() => {
                    // Beispiel: du könntest hier später navigieren oder Modal öffnen
                     navigate(`/fahrzeug/58`);
                  }}
                >
                  Zum Fahrzeug
                </Button>
              </Card.Body>
            </Card>
          </Col>

          <Col  md={3} sm={6} xs={12}>
            <Card className="h-100 shadow-sm">
              <Card.Body className="d-flex flex-column">
                <Card.Text className="fw-bold">KN-DH 443</Card.Text>

                <Button
                  variant="primary"
                  className="mt-auto"
                  onClick={() => {
                    // Beispiel: du könntest hier später navigieren oder Modal öffnen
                     navigate(`/fahrzeug/443`);
                  }}
                >
                  Zum Fahrzeug
                </Button>
              </Card.Body>
            </Card>
          </Col>

          <Col  md={3} sm={6} xs={12}>
            <Card className="h-100 shadow-sm">
              <Card.Body className="d-flex flex-column">
                <Card.Text className="fw-bold">KN-DH 46</Card.Text>

                <Button
                  variant="primary"
                  className="mt-auto"
                  onClick={() => {
                    // Beispiel: du könntest hier später navigieren oder Modal öffnen
                    navigate(`/fahrzeug/46}`);
                  }}
                >
                  Zum Fahrzeug
                </Button>
              </Card.Body>
            </Card>
          </Col>

          <Col  md={3} sm={6} xs={12}>
            <Card className="h-100 shadow-sm">
              <Card.Body className="d-flex flex-column">
                <Card.Text className="fw-bold">KN-DH 170</Card.Text>

                <Button
                  variant="primary"
                  className="mt-auto"
                  onClick={() => {
                    // Beispiel: du könntest hier später navigieren oder Modal öffnen
                     navigate(`/fahrzeug/170`);
                  }}
                >
                  Zum Fahrzeug
                </Button>
              </Card.Body>
            </Card>
          </Col>

          <Col  md={3} sm={6} xs={12}>
            <Card className="h-100 shadow-sm">
              <Card.Body className="d-flex flex-column">
                <Card.Text className="fw-bold">KN-DH 840</Card.Text>

                <Button
                  variant="primary"
                  className="mt-auto"
                  onClick={() => {
                    // Beispiel: du könntest hier später navigieren oder Modal öffnen
                     navigate(`/fahrzeug/840`);
                  }}
                >
                  Zum Fahrzeug
                </Button>
              </Card.Body>
            </Card>
          </Col>

         

          <Col  md={3} sm={6} xs={12}>
            <Card className="h-100 shadow-sm">
              <Card.Body className="d-flex flex-column">
                <Card.Text className="fw-bold">KN-DH 56</Card.Text>

                <Button
                  variant="primary"
                  className="mt-auto"
                  onClick={() => {
                    // Beispiel: du könntest hier später navigieren oder Modal öffnen
                     navigate(`/fahrzeug/56`);
                  }}
                >
                  Zum Fahrzeug
                </Button>
              </Card.Body>
            </Card>
          </Col>

          <Col  md={3} sm={6} xs={12}>
            <Card className="h-100 shadow-sm">
              <Card.Body className="d-flex flex-column">
                <Card.Text className="fw-bold">KN-DH 65</Card.Text>

                <Button
                  variant="primary"
                  className="mt-auto"
                  onClick={() => {
                    // Beispiel: du könntest hier später navigieren oder Modal öffnen
                     navigate(`/fahrzeug/65`);
                  }}
                >
                  Zum Fahrzeug
                </Button>
              </Card.Body>
            </Card>
          </Col>
   

          <Col  md={3} sm={6} xs={12}>
            <Card className="h-100 shadow-sm">
              <Card.Body className="d-flex flex-column">
                <Card.Text className="fw-bold">KN-DH 290</Card.Text>

                <Button
                  variant="primary"
                  className="mt-auto"
                  onClick={() => {
                    // Beispiel: du könntest hier später navigieren oder Modal öffnen
                     navigate(`/fahrzeug/290`);
                  }}
                >
                  Zum Fahrzeug
                </Button>
              </Card.Body>
            </Card>
          </Col>

          <Col  md={3} sm={6} xs={12}>
            <Card className="h-100 shadow-sm">
              <Card.Body className="d-flex flex-column">
                <Card.Text className="fw-bold">KN-DH 390</Card.Text>

                <Button
                  variant="primary"
                  className="mt-auto"
                  onClick={() => {
                    // Beispiel: du könntest hier später navigieren oder Modal öffnen
                     navigate(`/fahrzeug/390`);
                  }}
                >
                  Zum Fahrzeug
                </Button>
              </Card.Body>
            </Card>
          </Col>

          <Col  md={3} sm={6} xs={12}>
            <Card className="h-100 shadow-sm">
              <Card.Body className="d-flex flex-column">
                <Card.Text className="fw-bold">KN-DH 500</Card.Text>

                <Button
                  variant="primary"
                  className="mt-auto"
                  onClick={() => {
                    // Beispiel: du könntest hier später navigieren oder Modal öffnen
                     navigate(`/fahrzeug/500`);
                  }}
                >
                  Zum Fahrzeug
                </Button>
              </Card.Body>
            </Card>
          </Col>

          <Col  md={3} sm={6} xs={12}>
            <Card className="h-100 shadow-sm">
              <Card.Body className="d-flex flex-column">
                <Card.Text className="fw-bold">KN-DH 830</Card.Text>

                <Button
                  variant="primary"
                  className="mt-auto"
                  onClick={() => {
                    // Beispiel: du könntest hier später navigieren oder Modal öffnen
                     navigate(`/fahrzeug/830`);
                  }}
                >
                  Zum Fahrzeug
                </Button>
              </Card.Body>
            </Card>
          </Col>

          <Col  md={3} sm={6} xs={12}>
            <Card className="h-100 shadow-sm">
              <Card.Body className="d-flex flex-column">
                <Card.Text className="fw-bold">KN-DH 870</Card.Text>

                <Button
                  variant="primary"
                  className="mt-auto"
                  onClick={() => {
                    // Beispiel: du könntest hier später navigieren oder Modal öffnen
                     navigate(`/fahrzeug/870`);
                  }}
                >
                  Zum Fahrzeug
                </Button>
              </Card.Body>
            </Card>
          </Col>

          <Col  md={3} sm={6} xs={12}>
            <Card className="h-100 shadow-sm">
              <Card.Body className="d-flex flex-column">
                <Card.Text className="fw-bold">KN-DH 190</Card.Text>

                <Button
                  variant="primary"
                  className="mt-auto"
                  onClick={() => {
                    // Beispiel: du könntest hier später navigieren oder Modal öffnen
                     navigate(`/fahrzeug/190`);
                  }}
                >
                  Zum Fahrzeug
                </Button>
              </Card.Body>
            </Card>
          </Col>

          <Col  md={3} sm={6} xs={12}>
            <Card className="h-100 shadow-sm">
              <Card.Body className="d-flex flex-column">
                <Card.Text className="fw-bold">KN-DH 860</Card.Text>

                <Button
                  variant="primary"
                  className="mt-auto"
                  onClick={() => {
                    // Beispiel: du könntest hier später navigieren oder Modal öffnen
                    navigate(`/fahrzeug/860`);
                  }}
                >
                  Zum Fahrzeug
                </Button>
              </Card.Body>
            </Card>
          </Col>
      </Row>

      {/* Suchmodal */}
      <Modal
        size="lg"
        aria-labelledby="contained-modal-title-vcenter"
        centered
        show={modalShow}
        onHide={() => setModalShow(false)}
      >
        <Modal.Header closeButton>
          <Modal.Title id="contained-modal-title-vcenter">Historie suchen</Modal.Title>
        </Modal.Header>

        <Modal.Body style={{ paddingBottom: '60px' }}>
          <div
            style={{
              backgroundColor: '#eceff2',
              padding: '20px',
              borderRadius: '8px',
              cursor: 'text',
              borderBottom: inputFocused ? '3px solid #66bfff' : '3px solid #ccc',
              transition: 'border-color 0.3s ease',
            }}
            onClick={focusInput}
          >
            <Form
              onSubmit={(e) => {
                e.preventDefault();
                search();
              }}
            >
              <Form.Group controlId="exampleForm.ControlInput1" style={{ marginBottom: '0' }}>
                <Form.Control
                  ref={inputRef}
                  onFocus={() => setInputFocused(true)}
                  onBlur={() => setInputFocused(false)}
                  style={{
                    backgroundColor: 'transparent',
                    fontSize: '1.4rem',
                    border: 'none',
                    boxShadow: 'none',
                    outline: 'none',
                  }}
                  type="text"
                  placeholder="Suchbegriff eingeben"
                  value={searchfield}
                  onChange={(e) => setSearchfield(e.target.value)}
                />
              </Form.Group>

              <div className="d-flex gap-2 mt-3">
                <Button type="submit" variant="primary" disabled={loading}>
                  {loading ? 'Suche...' : 'Suchen'}
                </Button>
                <Button variant="outline-secondary" onClick={() => setModalShow(false)}>
                  Schließen
                </Button>
              </div>
            </Form>
          </div>

          {/* Optional: Ergebnisse aus "daten" anzeigen (wenn du willst) */}
          {/* <pre className="mt-3">{JSON.stringify(daten, null, 2)}</pre> */}
        </Modal.Body>
      </Modal>

      {/* Detail Modal */}
      <Modal size="xl" show={ModalTable} onHide={() => setModalTable(false)}>
        <Modal.Header closeButton>
          <Modal.Title>Detailanzeige zu Vertragsnummer {vertrag}</Modal.Title>
        </Modal.Header>

        <Modal.Body>
          <Row>
            {TableDaten && TableDaten.length > 0 ? (
              <Col xs={12}>
                <Table striped responsive bordered hover>
                  <thead>
                    <tr>
                      <th>Kundennummer</th>
                      <th>Anrede</th>
                      <th>Name</th>
                      <th>Vorname</th>
                      <th>Gebäude</th>
                      <th>Kommission 1</th>
                      <th>Kommission 2</th>
                      <th>Status Vertrag</th>
                      <th>Gebäude-Komplex</th>
                      <th>Winter/Sommer</th>
                      <th>Kompetenzstufe</th>
                    </tr>
                  </thead>
                  <tbody>
                    {TableDaten.map((v, index) => (
                      <tr key={index}>
                        <td>{v.KundeKundenNr}</td>
                        <td>{v.KundeAnrede}</td>
                        <td>{v.KundeName1}</td>
                        <td>{v.KundeName2}</td>
                        <td>{v.WAV_Gebaeude}</td>
                        <td>{v.WAV_Kommission1}</td>
                        <td>{v.WAV_Kommission2}</td>
                        <td>{v.WAV_AktivPassivStatus}</td>
                        <td>{v.WAV_GeabeudeKomplex}</td>
                        <td>{v.Zeit}</td>
                        <td>{v.Art}</td>
                      </tr>
                    ))}
                  </tbody>
                </Table>
              </Col>
            ) : (
              <Col className="text-center" xs={12}>
                <h3>Es sind keine weiteren Details verfügbar</h3>
              </Col>
            )}
          </Row>
        </Modal.Body>

        <Modal.Footer>
          <Button variant="secondary" onClick={() => setModalTable(false)}>
            Schließen
          </Button>
        </Modal.Footer>
      </Modal>
    </div>
  );
};

export default Carstock;
